import axios from '@/api/config';

const goodsItem = {
  getGoodsItemById(data) {
    return axios.get(`${process.env.BASE_URL}/goodsItem/getGoodsItem/` + data, {});
  },
  getGoodsItem(data) {
    return axios.get(`${process.env.BASE_URL}/goodsItem/getGoodsItem`, {
      params: data
    });
  },
  getGoodsItemList(data) {
    return axios.get(`${process.env.BASE_URL}/goodsItem/getGoodsItemList`, {
      params: data
    });
  },
  getGoodsItemTree(data) {
    return axios.get(`${process.env.BASE_URL}/goodsItem/getGoodsItemTree`, {
      params: data
    });
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/goodsItem/pageList`, data);
  },
  arrangePageList(data) {
    return axios.post(`${process.env.BASE_URL}/classInfoPhase/pageList`, data);
  },
  addGoodsItem(data) {
    return axios.post(`${process.env.BASE_URL}/goodsItem/addGoodsItem`, data);
  },
  updateGoodsItem(data) {
    return axios.put(`${process.env.BASE_URL}/goodsItem/updateGoodsItem`, data);
  },
  deleteGoodsItem(data) {
    return axios.delete(`${process.env.BASE_URL}/goodsItem/deleteGoodsItem`, {
      data: data
    });
  },
  unbindGoodsArrange(data) {
    return axios.delete(`${process.env.BASE_URL}/goodsInfo/unBindClassInfo`, {
      data: data
    });
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/goodsItem/exportExcel`, {
      params: data
    });
  },
  importData(data) {
    return axios.post(`${process.env.BASE_URL}/goodsItem/importData`, data);
  },
  addGoodsItemBatch(data, data2) {
    return axios.post(`${process.env.BASE_URL}/goodsItem/addGoodsItemBatch`, data, {
      params: data2
    });
  },
  pageListExamType(data) {
    return axios.post(`${process.env.BASE_URL}/subjectCourse/pageListExamType`, data);
  },
  addGoodsClassRelation(data) {
    return axios.post(`${process.env.BASE_URL}/goodsInfo/bindClassInfo`, data);
  },
  actualOperationPageList(data) {
    return axios.post(`${process.env.BASE_URL}/actualOperation/pageList`, data);
  }
}

export default goodsItem;



// WEBPACK FOOTER //
// ./src/api/goodsItem.js